<script>
    //PROPS
    export let message = '';
    export let loading = true;
    export let success = false;
    export let successLabel = 'Loading...';
    export let failLabel = '';

    //ARRAY FOR THE LOADER
    const arr = Array.from({ length: 11 });
</script>

<!-- ======================== HTML TEMPLATE ================================= -->
<div class="app-msi_message">
    {message}
</div>
<div class="app-msi_spinner app-msi_spinner-center" v-if="loading">
    {#each arr as n}
        <div class="app-msi_spinner-dot" v-for="n in 11" key={n} />
    {/each}
</div>
<div class="row">
    {#if !loading && success}
        <div class="col-12 app-msi_text-center">
            {successLabel}
        </div>
    {/if}
    {#if !loading && !success}
        <div class="col-12 app-msi_text-center">
            {failLabel}
        </div>
    {/if}
</div>
